import { useState, useEffect } from 'react';
import { MessageCircle, Phone, Mail, ChevronUp } from 'lucide-react';
import ContactModal from './ContactModal';

export default function FloatingCTA() {
  const [modalType, setModalType] = useState(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 320);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const buttons = [
    { icon: MessageCircle, label: 'WhatsApp', type: 'whatsapp', colour: 'bg-green-600 hover:bg-green-700' },
    { icon: Phone,         label: 'Call',     type: 'phone',    colour: 'bg-steel-800 hover:bg-steel-900' },
    { icon: Mail,          label: 'Email',    type: 'email',    colour: 'bg-steel-600 hover:bg-steel-700' },
  ];

  return (
    <>
      <div data-testid="floating-cta" className="fixed bottom-6 right-6 z-50 flex flex-col gap-2.5">

        {/* Back to top — appears on scroll */}
        <button
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`back-to-top bg-white border border-steel-200 text-steel-600 p-3 shadow-md hover:bg-steel-50 hover:text-steel-900 hover:-translate-y-0.5 transition-all duration-200 ${showTop ? 'visible' : 'hidden'}`}
        >
          <ChevronUp size={18} strokeWidth={2} />
        </button>

        {/* Contact buttons */}
        {buttons.map(btn => (
          <button
            key={btn.type}
            data-testid={`floating-cta-${btn.type}`}
            onClick={() => setModalType(btn.type)}
            className={`${btn.colour} text-white p-3 shadow-lg hover:-translate-y-1 transition-all duration-200 group relative`}
            aria-label={btn.label}
          >
            <btn.icon size={19} strokeWidth={1.5} />
            {/* Tooltip */}
            <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-steel-900 text-white text-[11px] font-mono uppercase tracking-wider px-3 py-1.5 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              {btn.label}
            </span>
          </button>
        ))}
      </div>

      {modalType && (
        <ContactModal type={modalType} onClose={() => setModalType(null)} />
      )}
    </>
  );
}
